/* jslint browser */

/* global window */

export function get(itemName) {
  try {
    return JSON.parse(window.localStorage.getItem(itemName));
  } catch (error) {
    return null;
  }
}

export function set(itemName, value) {
  window.localStorage.setItem(itemName, JSON.stringify(value));
}

export function clear() {
  window.localStorage.clear();
}

export function del(itemName) {
  window.localStorage.removeItem(itemName);
}

export const loadStorePart = part => {
  try {
    const serializedState = localStorage.getItem(`state_${part}`);
    if (serializedState !== null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return null;
  }
};

export const saveStorePart = (part, store) => {
  try {
    const serializedState = JSON.stringify(store);
    localStorage.setItem(`state_${part}`, serializedState);
  } catch (error) {
    // Ignore write errors
  }
};

export const cleanAllStore = () => {
  Object.keys(localStorage)
    .filter(k => k.indexOf('state_') >= 0)
    .forEach(k => localStorage.removeItem(k));
};

export const cleanStorePart = part => {
  try {
    localStorage.removeItem(part);
  } catch (error) {
    // Ignore errors
  }
};
